export default __webpack_public_path__ + "static/media/MyNotes.6698ecc1.PNG";